<template lang="pug">
  .coupon-layer
    .coupon-outer-wrapper
      img.close-icon(
        src="https://assets.51downapp.cn/file-1755074401506-985003683.png"
        alt=""
        @click="handleClose"
      )
      .layer-title
        img.unlock-icon(
          src="https://m.hellobike.com/resource/gallery/833/OgJQFfnZ_Vector.png"
          alt=""
        )
        .unlock-tips-text
          .title 解锁抽奖：
          .highlight 领取/使用
          .desc 任意一张会员专属券
      .layer-content(:class="freeVersionClass")
        RideCard(
          v-if="!isLadderVersion"
          :isPlayExchangeCoupon="false"
          :groups="groupsData"
          :couponGameAB="couponGameAB"
          :vipData="couponData"
          :isLotteryNew="isLotteryNew"
          @click-btn="firstStatus"
          @openExtend="openExchangeData"
          @open-exchange="openExchangeBlock"
        )
        .ladder-wrapper(v-else)
          .ladder-title
            .ladder-title-text 生活出行卡券
          FreeCouponTab(
            :groupList="groupList"
            :more="false"
            @clickReceiveButton="firstStatus"
          )
    ChangeExpansionCardModalContainer(
      v-if="showChangeModal"
      :show.sync="showChangeModal"
      :openChangeType="openChangeType"
      :goodsGuid="goodsGuid"
      :couponInfo="changeValue"
      :vipRecordGuid="vipRecordGuidData"
      :propVersion="propVersion"
      :extandData="extandData"
      @click-btn="firstStatus"
      @success="changeSuccess"
      @refresh="refreshData"
    )
    EquityModal(
      v-if="showEquityModal"
      :show.sync="showEquityModal"
      :couponInfo="openModalData"
      :isExpansiveSuccess="isExpansiveSuccess"
      @goToUse="goToModalUse"
      @refresh="refreshData"
    )
    ExchangeBlock(
      :show.sync="showExchangeBlock"
      :groups="exchangeList"
      :couponGameAB="couponGameAB"
      @changeIt="changeIt"
    )
     //- 红包组件
    ReceivePacket(
      v-if="showLadderCoupon"
      :show.sync="showLadderCoupon"
      :couponInfo="bigCouponInfo"
      @goToUse="goToLadderUse"
      @refresh="refreshData"
    )
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { Navigator } from '@hb/h5-navigator';
import { env } from '@hb/hbridge';
import { getNoScroll, getTokenAndKey } from '@/utils';
import deepCopy from '@/utils/deepCopy';
import { startApp } from '@/utils/index';
import { COUPON_STATUS } from '@/pages/vip/consts';
import { PropVersionMap } from '@/const/vip';
import { receiveVipCoupon } from '@/api/vip';
import { getSystemCode } from '@/utils/systemCode';
import Loading from '@/components/loading';
import Toast from '@/components/toast';
import { CouponMapper } from '../../utils';
import RideCard from '../ride-card.vue';
import ReceivePacket from '../receive-packet.vue';
import { getSource } from '../../../../../utils';
import FreeCouponTab from '../free-coupon-tab.vue';
import ExchangeBlock from '../exchange-block.vue';
import ChangeExpansionCardModalContainer from '../change-expansion-card-modal.vue';
import EquityModal from '../equity-modal.vue';

export default {
  name: 'CouponLayer',
  components: {
    RideCard,
    ReceivePacket,
    FreeCouponTab,
    ExchangeBlock,
    ChangeExpansionCardModalContainer,
    EquityModal,
  },
  props: {
    couponGameAB: {
      type: String,
      default: 'N',
    },
    vipData: {
      type: Object,
      default: () => ({}),
    },
    isLotteryNew: {
      type: Boolean,
      default: false,
    },
    currentOrderOptType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // vipData处理后的数据
      couponData: {},
      groupList: [],
      groupsOne: {},
      groupsOther: [],
      groups: [],
      ladderPropGroupList: [],
      // receive-packet相关数据
      showLadderCoupon: false,
      ladderReceiveCoupon: null,
      bigCouponInfo: {},
      loadingTimer: null,
      propVersion: null,
      showChangeModal: false,
      toReceiveCoupon: null,
      openChangeType: null, // 膨胀卡券类型 1.多选1
      changeValue: null,
      status: { ...COUPON_STATUS },
      willGuide: false,
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true&chInfo=ch_share__chsub_CopyLink&fxzjshareChinfo=ch_share__chsub_CopyLink&apshareid=DAEF5627-8D33-4E6E-9CE2-2A0FD137329B&shareBizType=mrfxzw',
        wechatLink: 'https://m.hellobike.com/mf/spa/u_sxnpet/latest/MA2412037285359647643402840.html?activityCode=MA2412037285359647643402840',
      },
      // 膨胀相关数据
      goodsGuid: null,
      vipRecordGuidData: null,
      extandData: {},
      showEquityModal: false,
      openModalData: {},
      showExchangeBlock: false,
      isExpansiveSuccess: false,
      exchangeList: [],
    };
  },
  computed: {
    // 根据单车试用版状态和订单类型判断返回的数据
    groupsData() {
      const isRideTrial = this.propVersion === PropVersionMap.RIDE_TRIAL;
      const isTrialOrder = [21, 50].includes(this.currentOrderOptType);

      if (isRideTrial && isTrialOrder) {
        return this.groupsOne;
      }
      return this.groupsOther[0];
    },
    isLadderVersion() {
      return this.propVersion ? this.propVersion.includes('ladder') : false;
    },
    freeVersionClass() {
      const classes = [];
      if (this.freeRightsVersion()) {
        classes.push('free-rights-version');
      }
      return classes;
    },
  },
  watch: {
    vipData: {
      deep: true,
      immediate: false,
      handler(val) {
        this.couponData = val;
        this.handleCouponData();
      },
    },
  },
  inject: ['freeRightsVersion'],
  mounted() {
    getNoScroll(true);
    this.couponData = deepCopy(this.vipData);
    this.handleCouponData();
  },
  beforeDestroy() {
    getNoScroll(false);
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
  },
  destroyed() {
    this.loadingTimer = null;
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleCouponData() {
      if (!this.couponData) {
        return;
      }
      const {
        groupList = [],
        propVersion,
        ladderGroupList = [],
        couponGameAB,
        goodsGuid,
        vipRecordGuid,
      } = this.couponData;

      this.propVersion = propVersion;
      this.couponGameAB = couponGameAB;
      this.goodsGuid = goodsGuid;
      this.vipRecordGuidData = vipRecordGuid;

      if (this.couponGameAB === 'Y') {
        UBT.moduleExpose({
          pageId: 'platform_ririchou',
          categoryId: 'platform',
          moduleId: 'platform_exchange_coupons',
          contentId: 'platform_exchange_coupons',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
      if (this.couponGameAB === 'N') {
        UBT.moduleExpose({
          pageId: 'platform_ririchou',
          categoryId: 'platform',
          moduleId: 'platform_Change_Record',
          contentId: 'platform_Change_Record',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
      // propTimes
      if (ladderGroupList.length) {
        this.ladderPropGroupList = ladderGroupList
          .map((ladderItem) => ({
            ...ladderItem,
            propList: ladderItem.propList.map(CouponMapper),
          }));
      }
      if (groupList.length) {
        this.groupList = [{ ...groupList[0], propList: groupList[0].propList.map(CouponMapper) }];
      }
      this.groups = groupList.map((g) => {
        const {
          groupName: title,
          groupDesc: subtitle,
          groupAmount: amount,
          isExclusive,
          propList = [],
          todayExpirePropNum,
          usablePropNum,
          groupIndex,
          groupCode,
          propIcon,
          goodsPropDesc,
          afterVipExtendProperty,
          afterVipRecycleProperty,
          afterVipReplacementProperty,
        } = g;
        return {
          title,
          amount,
          subtitle,
          isExclusive,
          propList,
          todayExpirePropNum,
          usablePropNum,
          groupIndex,
          groupCode,
          coupons: propList.map((item) => CouponMapper(item, propVersion)),
          type: 2,
          propIcon,
          goodsPropDesc,
          afterVipExtendProperty,
          afterVipRecycleProperty,
          afterVipReplacementProperty,
        };
      });
      [this.groupsOne, ...this.groupsOther] = this.groups;

      this.groupsOther.forEach((i, index) => {
        if (index < 2) {
          UBT.moduleExpose({
            pageId: 'platform_ririchou',
            categoryId: 'platform',
            moduleId: `platform_openedcard_model${index + 1}`,
            contentId: `platform_openedcard_model${index + 1}`,
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      });
    },
    // receive-packet相关方法
    refreshData() {
      this.$emit('refresh');
    },
    async openLadderCoupon(cp) {
      const coupon = this.ladderReceiveCoupon || cp;
      if (!coupon) {
        return;
      }
      UBT.clickButton({
        pageId: 'platform_PaidMemberDetail',
        buttonName: 'platform_receive',
        categoryId: 'platform',
        businessInfo: {
          BatchId: coupon.propCode || '',
          adsource: getSource(),
        },
      });
      const { token } = await getTokenAndKey();
      const { userVipPropGuid, propCode, propName } = coupon;
      receiveVipCoupon({
        token, userVipPropGuid, propCode, systemCode: getSystemCode(), propName,
      })
        .then((res) => {
          if (res.data.waitingTime) {
            Loading.show();
            this.loadingTimer = setTimeout(async () => {
              await Loading.close();
            }, res.data.waitingTime);
          }
          const { showLadderCoupon } = coupon;
          // showLadderCoupon 为false, 不展示弹窗
          if (showLadderCoupon === false) {
            return;
          }
          this.bigCouponInfo = CouponMapper(res.data);
          this.showLadderCoupon = true;
          this.showChangeModal = false;
        })
        .catch((e) => {
          Toast.showError(e);
        })
        .then(async () => {
          // this.getData();
          await this.refreshData();
          setTimeout(() => {
            this.$emit('refreshLottery');
          }, 500);
        });
    },
    async receiveCoupon(cp) {
      const coupon = this.toReceiveCoupon || cp;
      if (!coupon) {
        return;
      }
      UBT.clickButton({
        pageId: 'platform_PaidMemberDetail',
        buttonName: 'platform_receive',
        categoryId: 'platform',
        businessInfo: {
          BatchId: (coupon.detail && coupon.detail.propCode) || coupon.propCode || '',
          adsource: getSource(),
        },
      });
      const { token } = await getTokenAndKey();
      const { userVipPropGuid, propCode, propName } = coupon.detail || coupon;
      receiveVipCoupon({
        token, userVipPropGuid, propCode, systemCode: getSystemCode(), propName,
      })
        .then((res) => {
          if (res.data) {
            if (res.data.waitingTime) {
              Loading.show();
              this.loadingTimer = setTimeout(async () => {
                await Loading.close();
                Toast.show('领取成功');
                this.showChangeModal = false;
              }, res.data.waitingTime);
            } else {
              Toast.show('领取成功');
              this.showChangeModal = false;
            }
          } else {
            Toast.show('网络开小差');
          }
        })
        .catch((e) => {
          Toast.showError(e);
        })
        .then(() => {
          // this.getData();
          this.refreshData();
        });
    },
    openReceiveModal(item) {
      if ([PropVersionMap.LADDER,
        PropVersionMap.RIDE,
        PropVersionMap.LADDER_BLEND,
        PropVersionMap.LADDER_BLEND_TWO,
        PropVersionMap.RIDE_STEADY_VERSION,
        PropVersionMap.RIDE_RADICAL_VERSION,
      ].includes(this.propVersion)) {
        this.ladderReceiveCoupon = null;
        this.ladderReceiveCoupon = item;
        this.openLadderCoupon(item);
      } else {
        this.toReceiveCoupon = item;
        this.receiveCoupon(item);
      }
    },
    waitCoupon(coupon) {
      if ((coupon && coupon.detail && coupon.detail.receiveStartTime) || coupon.receiveStartTime) {
        // 当前时间
        const startTime = +new Date();
        // 领取开始时间
        const endTime = ([PropVersionMap.LADDER, PropVersionMap.RIDE].includes(this.propVersion))
          ? coupon.receiveStartTime
          : coupon.detail.receiveStartTime;
        // 相差时间
        const diff = endTime - startTime;
        if (diff > 0) {
          const day = Math.ceil(diff / (24 * 60 * 60 * 1000));
          Toast.show(`${day}天后可领取此立减券`);
        } else if ([PropVersionMap.LADDER,
          PropVersionMap.RIDE,
          PropVersionMap.LADDER_BLEND,
          PropVersionMap.LADDER_BLEND_TWO].includes(this.propVersion)) {
          this.openLadderCoupon(coupon);
        } else { this.receiveCoupon(coupon); }
      }
    },
    useCoupon(coupon) {
      if (coupon && coupon.detail && coupon.detail.propUrl) {
        if (this.propVersion !== PropVersionMap.LADDER) {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_openedcard_use_button',
            categoryId: 'platform',
            businessInfo: {
              adsource: getSource(),
            },
          });
        }
        this.willGuide = false;
        const url = ([PropVersionMap.LADDER,
          PropVersionMap.RIDE].includes(this.propVersion)) ? coupon.propUrl : coupon.detail.propUrl;
        Navigator.go(url);
      }
    },
    goUrl(url = this.config.deepLink, download = false) {
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      window.location.href = url;
    },
    firstStatus(item) {
      if (item.status === 9 || item.status === 10) {
        this.showChangeModal = true;
        this.openChangeType = 3;
        this.changeValue = item;
        return;
      }
      if (item.status === this.status.locked) return;
      if (this.propVersion === PropVersionMap.LADDER) {
        if (item.status === this.status.use) {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_coupon_use',
            categoryId: 'platform',
            businessInfo: {
              BusinessLine: item.propBusinessLine,
            },
          });
        } else if (item.status === this.status.receive) {
          UBT.clickButton({
            pageId: 'platform_openedcard_page',
            buttonName: 'platform_coupon_get',
            categoryId: 'platform',
            businessInfo: {
              BusinessLine: item.propBusinessLine,
            },
          });
        }
      }

      if (env.isEasyBikeApp) {
        if (item.status === this.status.use) {
          this.useCoupon(item);
        } else if (item.status === this.status.receive) {
          this.openReceiveModal(item);
        } else if (item.status === this.status.wait) {
          this.waitCoupon(item);
        }
      } else if (item.status === this.status.use) {
        if (this.propVersion !== PropVersionMap.RIDE_UNIVERSAL) {
          if (env.isWeixin || env.isWechatMini) {
            this.goUrl(this.config.wechatLink, true);
          } else {
            this.goUrl(this.config.deepLink, true);
          }
        } else {
          Navigator.go(item.propUrl || (item.detail && item.detail.propUrl) || '');
        }
      } else if (item.status === this.status.receive) {
        this.openReceiveModal(item);
      } else if (item.status === this.status.wait) {
        this.waitCoupon(item);
      }
    },
    goToLadderUse(couponInfo) {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_coupon_pop',
        categoryId: 'platform',
        businessInfo: {
          BusinessLine: couponInfo.propBusinessLine,
        },
      });
      // this.getData();
      this.refreshData();
      if (couponInfo.status === this.status.use) {
        if (env.isEasyBikeApp) {
          this.useCoupon(couponInfo);
        } else {
          this.goUrl(this.config.deepLink, true);
        }
      }
    },
    // 膨胀相关逻辑
    openExchangeData(val) {
      // 膨胀券弹窗打开
      this.openChangeType = 3;
      this.showChangeModal = true;
      this.changeValue = val;
    },
    changeSuccess(val) {
      this.showEquityModal = true;
      this.openModalData = val;
      this.showChangeModal = false;
      this.showExchangeBlock = false;
      this.isExpansiveSuccess = true;
      this.refreshData();
    },
    openExchangeBlock(val) {
      this.showExchangeBlock = true;
      this.exchangeList = val;
    },
    changeIt(val, item) {
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_Exchange_coupons_choice',
        contentId: 'platform_Exchange_coupons_choice',
        exposureTimes: 1,
        businessInfo: {},
      });
      this.openChangeType = val;
      this.changeValue = item;
      this.showChangeModal = true;
    },
    goToModalUse(couponInfo) {
      if (couponInfo.sceneKey === 'remindReceiveProp') {
        this.receiveCoupon(couponInfo);
      } else if (env.isEasyBikeApp) {
        this.useCoupon(couponInfo);
      } else {
        this.goUrl(this.config.deepLink, true);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.coupon-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  .coupon-outer-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(178.01deg, #fbf1e0 16.73%, #fff 66.86%);
    border-radius: 0.22rem 0.22rem 0 0;
    overflow: auto;
    padding-bottom: 0.25rem;
    border-top: 0.02rem solid #fff;

    .close-icon {
      position: absolute;
      top: 0.14rem;
      right: 0.14rem;
      width: 0.16rem;
      height: 0.16rem;
    }

    .layer-title {
      padding: 0.2rem 0 0.06rem 0.18rem;
      display: flex;
      align-items: center;

      .unlock-icon {
        width: 0.09rem;
        height: 0.11rem;
        margin-right: 0.08rem;
      }

      .unlock-tips-text {
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        color: #242729;
        font-weight: 500;

        .highlight {
          color: #ff5729;
        }

        .desc {
          font-weight: 400;
        }
      }
    }

    .layer-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .ladder-wrapper {
        margin: 0.1rem;
        background: #fff;
        padding: 0.13rem 0 0.12rem 0.12rem;
        border-radius: 0.16rem;
        width: 3.51rem;

        .ladder-title {
          align-items: center;
          display: flex;
          height: 0.22rem;
          margin-bottom: 0.14rem;

          .ladder-title-text {
            margin-left: 0.04rem;
            height: 0.22rem;
            font-size: 0.16rem;
            font-weight: 500;
            color: #242729;
            line-height: 0.22rem;
          }
        }
      }
    }
  }
}
</style>
